import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, Subscription} from 'rxjs';

import {MenuItem} from '@models/sidebar/menu-item';

import {ToggleFavoriteService} from '@services/left-menu/favorites/toggle-favorite/toggle-favorite.service';
import {LeftMenuService} from '@services/left-menu/left-menu.service';
import {MenuItemType} from '@models/sidebar/menu-item-type';
import {StorageService} from '@services/storage/storage.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'scitis-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    standalone: false
})
export class MenuItemComponent implements OnInit, OnDestroy {

  @Input()
  menuItem: MenuItem = new MenuItem();

  @Input()
  expandedNodeId: string | null = null;

  @Input()
  expandNodeInProgress: boolean = false;

  @Input()
  nodeUserMenuItems: MenuItem[] = [];

  @Input()
  showNodeUserMenuItems: boolean = false;

  @Input()
  firebaseUserId: string = '';

  @Input()
  fireMenuItemSelectAction: boolean = true;

  @Input()
  interactiveDataAnalysisMenuItem: MenuItem | undefined;

  @Input()
  useHighlighting: boolean = false;

  @Input()
  highlightTerms: string[] = [];

  @Input()
  isLoadingMenuItemParent: boolean = false;


  @Output()
  menuItemSelected: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  private subscription: Subscription = new Subscription();

  constructor(
      private toggleFavoriteService: ToggleFavoriteService,
      private leftMenuService: LeftMenuService,
      private storageService: StorageService,
      private translationService: TranslateService) {
  }

  get tooltip(): Observable<string> {
    return this.toggleFavoriteService.getTooltip(this.menuItem);
  }

  get currentNodeIsSelected(): boolean {
    return String(this.expandedNodeId) === String(this.menuItem.id);
  }

  get commands(): any[] | undefined {
    return this.leftMenuService.getCommands(this.menuItem, this.firebaseUserId, this.interactiveDataAnalysisMenuItem);
  }

 public get menuItemName(): string {
    if(MenuItemType.DATA_VISUALIZATION_PAGE === this.menuItem.type){
      return this.translationService.instant('Interactive Data Analysis');
    }
    return this.menuItem.name;
  }

  get iconClass(): string {
    if (this.expandNodeInProgress && String(this.expandedNodeId) === String(this.menuItem.id)) {
      return 'fa-spinner-third fad fa-spin';
    } else {
      return this.menuItem.icon ? this.menuItem.icon.toString() : '';
    }
  }

  ngOnInit() {

    this.removeQuotesFromHighlightingTerms(this.highlightTerms);

    if (this.firebaseUserId === '') {
      this.firebaseUserId = this.menuItem.firebaseUserId;
    }
    this.subscription = this.toggleFavoriteService.removeFavoriteItem
    .subscribe((removedFavoriteMenuItem: MenuItem) => {
      if (String(removedFavoriteMenuItem.id) === String(this.menuItem.id)) {
        this.menuItem.isFavorite = false;
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  toggleFavorite(event: any): void {
    this.toggleFavoriteService.toggleFavorite(event, this.menuItem, this.firebaseUserId);
  }

  onMenuItemSelected(event: any): void {
    event.preventDefault();
    if (!this.fireMenuItemSelectAction) {
      return;
    }
    this.menuItemSelected.emit(this.menuItem);
    if (this.menuItem.type === MenuItemType.NODE) {
      //navigating to page under node is handled in menu-overview.component
      return;
    }
    if (this.menuItem.type === MenuItemType.MACHINE_GROUP) {
      this.storageService.writeValueToIndexedDb('activeGroupName', this.menuItem.name);
    }
    this.leftMenuService.navigateToPage(this.commands);
  }

  private removeQuotesFromHighlightingTerms(highlightTerms: string[]) {
    for (let i = 0; i < highlightTerms.length; i++) {
      highlightTerms[i] = highlightTerms[i].replaceAll('"', '');
    }
    this.highlightTerms = [...highlightTerms];
  }
}
